import React from 'react';
import Image from 'next/image';
import styles from './sobre-nos.module.css';

const SobreNos: React.FC = () => {
  const handleNavigateSocialMedias = (url: string) => {
    window.open(url, '_blank');
  };

  const handleNavigateToHome = () => {
    window.open('/', '_self');
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <Image
            src="/images/sobre-nos/getninjas.webp"
            alt="GetNinjas"
            width={135}
            height={29}
            priority
            onClick={handleNavigateToHome}
            style={{
              cursor: 'pointer',
            }}
          />
        </div>
      </header>

      {/* Hero Section - Quem somos? */}
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1>Quem somos?</h1>
            <p>
              Somos a maior plataforma online de serviços, conectando clientes a
              profissionais, ou seja, juntando quem precisa de algo com que sabe
              fazer.
            </p>
            <p>
              O nosso aplicativo oferece serviços em diversas categorias – são
              mais de 500 tipos, que vão desde serviços domésticos e reformas e
              reparos, a moda e beleza e eventos.
            </p>
          </div>
          <div className={styles.heroImage}>
            <Image
              src="/images/sobre-nos/hero.webp"
              alt="Equipe GetNinjas"
              width={450}
              height={677}
            />
          </div>
        </div>
      </section>

      {/* Nossa História */}
      <section className={styles.historiaSection}>
        <div className={styles.historiaSectionContent}>
          <h2>Nossa história</h2>
          <p>
            O GetNinjas foi criado em 2011, como uma plataforma online para dar
            aos profissionais de diversas áreas a possibilidade de anunciarem os
            seus serviços. Com isso, é possível que os clientes encontrem os
            prestadores de serviços ideais para as suas necessidades, de forma
            rápida e prática.
          </p>
          <p>
            Em 2011, quando o fundador da empresa precisou de um pintor, ele
            procurou nas páginas amarelas um profissional. Entretanto, o serviço
            não foi o que esperava e o fez pensar por que não ter um lugar onde
            seria possível encontrar os melhores profissionais do mercado. Foi
            aí que surgiu a ideia do GetNinjas.
          </p>
          <p>
            Dois anos mais tarde, em 2013, o Google citou a empresa como uma das
            mais incríveis, mostrando que estávamos indo no caminho certo! Já em
            2017, o GetNinjas foi eleito pela Forbes Brasil uma das companhias
            mais promissoras.
          </p>
        </div>
      </section>

      {/* Como funciona */}
      <section className={styles.funcionaSection}>
        <div className={styles.sectionContent}>
          <h2>Como funciona o GetNinjas</h2>
          <p className={styles.subtitle}>
            Pelo app ou site, conectamos quem precisa com quem sabe fazer!
          </p>

          <div className={styles.funcionaGrid}>
            <div className={styles.funcionaCard}>
              <h3>O GetNinjas para cliente:</h3>
              <p>
                Pelo nosso app ou site, você descreve o que precisa e em menos
                de uma hora (em média) até 4 profissionais podem entrar em
                contato com você para te passar o orçamento.
              </p>
            </div>

            <div className={styles.funcionaCard}>
              <h3>O GetNinjas para profissional:</h3>
              <p>
                Pelo app, você consegue oportunidades de clientes na sua região
                e escolhe quais quer atender. Ao liberar uma oportunidade, você
                negocia diretamente com o cliente e estabelece seus próprios
                preços.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Nossos Valores */}
      <section className={styles.valoresSection}>
        <div className={styles.valoresSectionContent}>
          <h2>Nossos valores</h2>

          <div className={styles.valoresGrid}>
            <div className={styles.valoresColumn}>
              <div className={styles.valorCard}>
                <div className={styles.valorIcon}>
                  <Image
                    src="/images/sobre-nos/valores1.webp"
                    alt="Um milhão de histórias"
                    width={40}
                    height={40}
                  />
                </div>
                <h3>Um milhão de histórias</h3>
                <p>
                  Temos a grande missão de impactar a vida de milhares de
                  pessoas e fazer parte de um milhão de histórias
                </p>
              </div>

              <div className={styles.valorCard}>
                <div className={styles.valorIcon}>
                  <Image
                    src="/images/sobre-nos/valores2.webp"
                    alt="Priorize e simplifique"
                    width={40}
                    height={40}
                  />
                </div>
                <h3>Priorize e simplifique</h3>
                <p>
                  Somos ninjas em priorizar e simplificar as tarefas do dia a
                  dia
                </p>
              </div>

              <div className={styles.valorCard}>
                <div className={styles.valorIcon}>
                  <Image
                    src="/images/sobre-nos/valores3.webp"
                    alt="Ideias valem mais do que cargos"
                    width={40}
                    height={40}
                  />
                </div>
                <h3>Ideias valem mais do que cargos</h3>
                <p>
                  Ninjas são criativos e sempre tem novas ideias, e boas ideias
                  valem mais do que cargos
                </p>
              </div>
            </div>

            <div className={styles.valoresColumn}>
              <div className={styles.valorCard}>
                <div className={styles.valorIcon}>
                  <Image
                    src="/images/sobre-nos/valores4.webp"
                    alt="Seu problema, meu problema"
                    width={40}
                    height={40}
                  />
                </div>
                <h3>Seu problema, meu problema</h3>
                <p>
                  Não temos medo de nos aventurar em uma função que não é
                  originalmente nossa, se esta atitude colaborar para o bem
                  coletivo
                </p>
              </div>

              <div className={styles.valorCard}>
                <div className={styles.valorIcon}>
                  <Image
                    src="/images/sobre-nos/valores5.webp"
                    alt="Foco em resultado"
                    width={40}
                    height={40}
                  />
                </div>
                <h3>Foco em resultado</h3>
                <p>
                  Buscamos entregar o máximo valor aos nossos usuários com muito
                  foco em resultado. Somos analíticos e aprendemos rápido,
                  sempre escutando nossos usuários
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Números */}
      <section className={styles.numerosSection}>
        <div className={styles.numerosSectionContent}>
          <h2>O GetNinjas em números</h2>

          <div className={styles.numerosGrid}>
            <div className={styles.numeroCard}>
              <h3>+5 milhões</h3>
              <p>de profissionais cadastrados</p>
            </div>

            <div className={styles.numeroCard}>
              <h3>+5 milhões</h3>
              <p>de pedidos de serviços por ano</p>
            </div>

            <div className={styles.numeroCard}>
              <h3>+500 tipos de serviços</h3>
              <p>para você contratar ou oferecer</p>
            </div>

            <div className={styles.numeroCard}>
              <h3>cerca de R$ 1 bilhão</h3>
              <p>
                movimentado em serviços por ano no bolso dos nossos
                profissionais
              </p>
            </div>
          </div>

          <div className={styles.numeroDestaque}>
            <div className={styles.iconClock}>
              <Image
                src="/images/sobre-nos/relogio.webp"
                alt="Relógio"
                width={78}
                height={78}
              />
            </div>
            <div className={styles.numeroDestaqueText}>
              <h3>A cada 30 segundos</h3>
              <p>um negócio é fechado aqui no GetNinjas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mercado de Serviços */}
      <section className={styles.blogSection}>
        <div className={styles.blogSectionContent}>
          <p className={styles.hashtag}>#MercadoDeServiços</p>

          <div className={styles.blogGrid}>
            <article className={styles.blogCard}>
              <div className={styles.blogImage}>
                <Image
                  src="/images/sobre-nos/servico1.webp"
                  alt="Tendências para o setor de serviços"
                  width={280}
                  height={168}
                />
              </div>
              <h3>Tendências para o setor de serviços em 2022</h3>
              <p>
                A pandemia consolidou a digitalização da prestação de serviços e
                que há uma demanda massiva voltada para o bem-estar e melhorias
                domésticas. É o que mostra a análise de mais de 3,9 milhões de
                pedidos feitos...
              </p>
              <a
                href="https://mercadoeconsumo.com.br/21/02/2022/destaque-do-dia/confira-as-tendencias-para-o-setor-de-servicos-em-2022/"
                target="_blank"
                className={styles.readMore}
                rel="noreferrer"
              >
                Leia mais
              </a>
            </article>

            <article className={styles.blogCard}>
              <div className={styles.blogImage}>
                <Image
                  src="/images/sobre-nos/servico2.webp"
                  alt="Interesse pelo skate"
                  width={280}
                  height={168}
                />
              </div>
              <h3>Interesse pelo skate cresce após a olimpíada</h3>
              <p>
                Com os olhos voltados para a Olimpíada de Tóquio, os brasileiros
                começaram a mostrar maior interesse na prática de alguns dos
                esportes olímpicos. E o skate têm ganhado destaque.
              </p>
              <a
                href="https://www.band.com.br/bandnews-fm/noticias/interesse-pela-pratica-do-skate-cresce-apos-a-olimpiada-de-toquio-16364556"
                target="_blank"
                className={styles.readMore}
                rel="noreferrer"
              >
                Leia mais
              </a>
            </article>

            <article className={styles.blogCard}>
              <div className={styles.blogImage}>
                <Image
                  src="/images/sobre-nos/servico3.webp"
                  alt="Demanda por shows"
                  width={280}
                  height={168}
                />
              </div>
              <h3>Demanda por shows no Brasil cresce 276%</h3>
              <p>
                Após sofrer com os efeitos da pandemia, o mercado de eventos
                registrou um crescimento de 179% na procura por profissionais
                que atuam na área no segundo trimestre de 2022, em comparação
                com o mesmo período...
              </p>
              <a
                href="https://www.cnnbrasil.com.br/economia/macroeconomia/demanda-por-shows-no-brasil-cresce-276-em-um-ano-mostra-levantamento/"
                target="_blank"
                className={styles.readMore}
                rel="noreferrer"
              >
                Leia mais
              </a>
            </article>
          </div>
        </div>
      </section>

      {/* Time de Ninjas */}
      <section className={styles.timeSection}>
        <div className={styles.timeSectionContent}>
          <div className={styles.timeImages2}>
            <Image
              src="/images/sobre-nos/time2.webp"
              alt="Time GetNinjas"
              width={341}
              height={311}
            />
          </div>

          <div className={styles.timeContent}>
            <h2>Nosso time de Ninjas</h2>
            <p>
              Hoje, temos mais 150 profissionais que trabalham no GetNinjas e
              estão revolucionando o mercado de serviços – que cresce cada vez
              mais!
            </p>

            <div className={styles.timeCallout}>
              <h3>Venha ser um Ninja!</h3>
              <p>
                Você manda bem em uma área e quer nos ajudar a mudar o mercado
                de prestação de serviços? Então vem trabalhar com a gente!
              </p>
              <a href="/carreiras" className={styles.btnPrimary}>
                Confira nossas vagas
              </a>
            </div>
          </div>

          <div className={styles.timeImages1}>
            <Image
              src="/images/sobre-nos/time1.webp"
              alt="Time GetNinjas"
              width={315}
              height={311}
            />
          </div>
        </div>
      </section>

      {/* Contato */}
      <section className={styles.contatoSection}>
        <div className={styles.contatoSectionContent}>
          <h2>Fale com a gente:</h2>

          <div className={styles.contatoGrid}>
            <div className={styles.contatoCard}>
              <div className={styles.contatoIcon}>
                <Image
                  src="/images/sobre-nos/email.webp"
                  alt="Email"
                  width={90}
                  height={90}
                />
              </div>
              <p>Para informações ou dúvidas entre em contato com:</p>
              <a href="mailto:contato@getninjas.com.br">
                contato@getninjas.com.br
              </a>
            </div>

            <div className={styles.contatoCard}>
              <div className={styles.contatoIcon}>
                <Image
                  src="/images/sobre-nos/microfone.webp"
                  alt="Assessoria"
                  width={90}
                  height={90}
                />
              </div>
              <p>
                É jornalista e quer entrar em contato com a nossa assessoria?
              </p>
              <a href="mailto:getninjas@focal3.com.br">
                getninjas@focal3.com.br
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Redes Sociais */}
      <section className={styles.redesSection}>
        <div className={styles.redesSectionContent}>
          <h2>Acompanhe nossos canais e fique por dentro das novidades!</h2>
          <p className={styles.redesSubtitle}>
            Leve a cultura Ninja para seu dia a dia. Em nossas redes você vê de
            perto a revolução no mercado de serviços:
          </p>

          <div className={styles.redesGrid}>
            <div
              className={styles.redeCard}
              onClick={() =>
                handleNavigateSocialMedias(
                  'https://www.linkedin.com/company/getninjas/'
                )
              }
            >
              <div className={styles.redeIcon}>
                <Image
                  src="/images/sobre-nos/linkedin.webp"
                  alt="LinkedIn"
                  width={41}
                  height={42}
                />
              </div>
              <h3>Linkedin</h3>
              <p>Acompanhe o que postamos e siga o Linkedin do GetNinjas.</p>
            </div>

            <div
              className={styles.redeCard}
              onClick={() =>
                handleNavigateSocialMedias(
                  'https://www.glassdoor.com.br/Vis%C3%A3o-geral/Trabalhar-na-GetNinjas-EI_IE1493964.13,22.htm'
                )
              }
            >
              <div className={styles.redeIcon}>
                <Image
                  src="/images/sobre-nos/glassdor.webp"
                  alt="Glassdoor"
                  width={32}
                  height={43}
                />
              </div>
              <h3>Glassdoor</h3>
              <p>Como é trabalhar no GetNinjas? Visite nosso Glassdoor!</p>
            </div>

            <div
              className={styles.redeCard}
              onClick={() =>
                handleNavigateSocialMedias(
                  'https://www.instagram.com/getninjas/?hl=pt'
                )
              }
            >
              <div className={styles.redeIcon}>
                <Image
                  src="/images/sobre-nos/instagram.webp"
                  alt="Instagram"
                  width={42}
                  height={42}
                />
              </div>
              <h3>Instagram</h3>
              <p>Acompanhe nossas postagens no Instagram.</p>
            </div>

            <div
              className={styles.redeCard}
              onClick={() =>
                handleNavigateSocialMedias(
                  'https://www.youtube.com/channel/UCWgyIuQWHB3u88SY1hr5zZg'
                )
              }
            >
              <div className={styles.redeIcon}>
                <Image
                  src="/images/sobre-nos/youtube.webp"
                  alt="Youtube"
                  width={47}
                  height={35}
                />
              </div>
              <h3>Youtube</h3>
              <p>Acompanhe nosso canal no Youtube.</p>
            </div>
          </div>
        </div>
      </section>

      {/* App Download */}
      <section className={styles.appSection}>
        <div className={styles.sectionContent}>
          <h2>Baixe nosso app</h2>
          <p>Contrate ou ofereça mais de 500 tipos de serviços agora mesmo!</p>

          <div className={styles.appBadges}>
            <a
              href="https://play.google.com/store/apps/details?id=br.com.getninjas.pro&hl=pt&gl=US"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/images/sobre-nos/google-play.webp"
                alt="Google Play"
                width={160}
                height={48}
              />
            </a>
            <a
              href="https://apps.apple.com/br/app/getninjas-para-profissional/id969564418"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/images/sobre-nos/app-store.webp"
                alt="App Store"
                width={143}
                height={48}
              />
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <Image
            src="/images/sobre-nos/getninjas.webp"
            alt="GetNinjas"
            width={135}
            height={29}
            onClick={handleNavigateToHome}
            style={{
              cursor: 'pointer',
            }}
          />
          <p>
            ©2011-2024, GetNinjas LTDA. CNPJ 55.744.877/0001-89 - Rua Dr.
            Fernandes Coelho, 85 - 3º Andar - Pinheiros - São Paulo/SP - Brasil
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SobreNos;
